'use strict';
const Ajax = require('common/infra/ajax');

class API {
    getLoginUser() {
        return Ajax.GET('/api/me');
    }

    updateLoginUser(userJSON) {
        return Ajax.PUT('/api/me', userJSON);
    }

    getJijiUser() {
        return Ajax.GET('/api/my/jiji');
    }

    getUser(id) {
        return Ajax.GET(`/api/users/${id}`);
    }

    createUser(json) {
        return Ajax.POST(`/api/users`, json);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./common/infra/api/user.js